export type BaseTranslations = Awaited<ReturnType<(typeof translations)['messages']['En_Us']>>

const translations = {
  messages: {
    En_Us: () => import('./Translations/en-US.json'),
  },
}

export default translations
